export const useLocaleMenuStore = defineStore('localeMenu', () => {
  const localeMenu = ref([] as DMenuItem[])

  function setMenu(menu: DMenuItem[]) {
    localeMenu.value = menu
  }

  return { localeMenu: readonly(localeMenu), setMenu }
})
